// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__nUUwI","spin":"Spinner_spin__E-qbf","light":"Spinner_light__vTg31","dark":"Spinner_dark__a7xY-","spinner-relative":"Spinner_spinner-relative__R8rr8"};